import { render, staticRenderFns } from "./PFWaiverListFront.vue?vue&type=template&id=27d064f3"
import script from "./PFWaiverListFront.vue?vue&type=script&lang=js"
export * from "./PFWaiverListFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports